import React, { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import AdminLayout from '../../../components/AdminLayout/AdminLayout';
import DashboardMainContainer from '../../../components/common/Containers/DashboardMainContainer';
import {
  AdminPageTitle,
  AdminSupportingText,
  AdminHeaderAction,
  ADMIN_PAGE_TITLE_CLASS,
  ADMIN_FORM_PANEL_CLASS,
} from '../shared/adminUx';
import { APPEALS_CONFIG_ROUTE } from '../../../data/appealsConfig';

/**
 * Test & Simulation is not part of Configuration — Appeals (Revision Pass 2).
 * Redirects to the Appeal list.
 */
const AppealsTestSimulation = () => {
  const navigate = useNavigate();
  const { configId } = useParams();

  useEffect(() => {
    const timer = setTimeout(() => {
      navigate(APPEALS_CONFIG_ROUTE, { replace: true });
    }, 1200);
    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <AdminLayout>
      <AdminPageTitle className={ADMIN_PAGE_TITLE_CLASS}>Appeal</AdminPageTitle>
      <DashboardMainContainer className={ADMIN_FORM_PANEL_CLASS}>
        <AdminSupportingText className="text-offblack mb-4">
          Test &amp; Simulation is not included in Configuration — Appeals. Returning to
          Appeal{configId ? ` (${configId})` : ''}.
        </AdminSupportingText>
        <AdminHeaderAction type="button" onClick={() => navigate(APPEALS_CONFIG_ROUTE)}>
          Back to Appeals
        </AdminHeaderAction>
      </DashboardMainContainer>
    </AdminLayout>
  );
};

export default AppealsTestSimulation;
